import React from 'react';
import { GenericPageLayout } from 'layouts/genericPage.layout';

export const ErrorPage = () => {
  return (
    <div className="response-expired">
      <GenericPageLayout
        pageClassName="response--wrapper"
        isOTPActivated={false}
        showOTPNotification={false}
        showTopLinks={false}
      >
        <div className="content-wrapper">
          <div className="error-message">
            Sorry, unable to retrieve the response attachments
          </div>
        </div>
      </GenericPageLayout>
    </div>
  );
};

ErrorPage.displayName = 'ErrorPage';

export default ErrorPage;
